// client/src/styles/globalAdAreaStyles.js
import { styled } from 'baseui';

export const StyledInsAd = styled('ins', {
  display: 'block',
});

export const StyledDevAdContainer = styled('div', {
  width: '100%',
  height: '100%', // Assuming this is the height of the parent container
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f0f0f0', // Placeholder, as it's dev mode
  color: '#333', // Placeholder
  border: '1px dashed #ccc', // Placeholder
});
